import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetCheckAddressRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetCheckAddressResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getCheckAddress = (request: GetCheckAddressRequest, options?: CashRequestOptions) =>
  post<GetCheckAddressRequest, GetCheckAddressResponse>('/2.0/cash/get-check-address', request, {
    ...options,
    rejectOnError: true,
  })
